export default "__VITE_ASSET__BBQahQLG__"